module.exports = __webpack_public_path__ + "img/12.1c909081.jpg";